import React from "react";
import "./range-slider.style.scss";

let max = 1000000;
export default function RangeSlider({ handleMinValue, handleMaxValue }) {
  const [minValue, setMinValue] = React.useState(0);
  const [maxValue, setMaxValue] = React.useState(max);
  const minValueRef = React.useRef(0);
  const maxValueRef = React.useRef(max);
  const sliderRef = React.useRef();
  const [dMinValue, setDMinValue] = React.useState(0);
  const [dMaxValue, setDMaxValue] = React.useState(max);
  const getPercent = React.useCallback(
    (value) => Math.round(((value - 0) / (max - 0)) * 100),
    []
  );

  React.useEffect(() => {
    const minPercent = getPercent(minValue);
    const maxPercent = getPercent(maxValueRef.current);

    if (sliderRef.current) {
      sliderRef.current.style.left = `${minPercent}%`;
      sliderRef.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minValue, getPercent]);
  React.useEffect(() => {
    const minPercent = getPercent(minValue);
    const maxPercent = getPercent(maxValueRef.current);

    if (sliderRef.current) {
      sliderRef.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxValue, getPercent]);
  return (
    <div className="range-slider-main-wrapper">
      <div className="range-slider-main">
        <input
          min={0}
          max={max}
          value={minValue}
          onChange={(e) => {
            let val = Math.min(Number(e.target.value), maxValue - 1);
            setMinValue(val);
            minValueRef.current = val;
          }}
          onMouseUp={(e) => handleMinValue(e.target.value)}
          className="input-range i-r__left"
          type="range"
          style={{ zIndex: minValue > max - 100 && "5" }}
        />
        <input
          min={0}
          max={max}
          value={maxValue}
          onChange={(e) => {
            let val = Math.max(Number(e.target.value), minValue + 1);
            setMaxValue(val);
            maxValueRef.current = val;
          }}
          onMouseUp={(e) => handleMaxValue(e.target.value)}
          className="input-range i-r__right"
          type="range"
        />
        <div className="ranger-slider">
          <div className="range-slider-track" />
          <div ref={sliderRef} className="range-slider-range" />
        </div>
      </div>
      <div className="range-slider-inputs">
        {/* <span>{"₹" + minValue}</span>
        <span>{"₹" + maxValue}</span> */}
        <input
          onKeyPress={(e) => {
            if (e.which === 13) {
              if (e.target.value < 0 || e.target.value > maxValue) {
                setDMinValue(minValue);
                return;
              }
              let val = Math.min(Number(e.target.value), maxValue - 1);
              setMinValue(val);
              minValueRef.current = val;
              handleMinValue(val.toString());
            }
          }}
          onChange={(e) => {
            // if (e.target.value < 0 || e.target.value > maxValue) return;
            setDMinValue(e.target.value);
          }}
          value={dMinValue}
        />
        <input
          onKeyPress={(e) => {
            if (e.which === 13) {
              if (e.target.value < minValue || e.target.value > 1000000) {
                setDMaxValue(maxValue);
                return;
              }
              let val = Math.max(Number(e.target.value), minValue + 1);
              setMaxValue(val);
              maxValueRef.current = val;
              handleMaxValue(val);
            }
          }}
          onChange={(e) => {
            // if (e.target.value < minValue || e.target.value > 1000000) return;
            setDMaxValue(e.target.value);
          }}
          value={dMaxValue}
        />
        {/* <input value={'₹'+minValue * 1000} placeholder="min" />
          <input value={maxValue * 1000} placeholder="max" /> */}
      </div>
    </div>
  );
}
